import { Card, Col, Row } from "antd";
import React from "react";
import { Navigate } from "react-router-dom";
import { checkTokenExp, logout } from "../../../utils/checkTokenExp";

import DemoLine from "./Demoline";
import QuickMetrics from "./QuickMetrics";
import SalePurchaseSplit from "./SalePurchaseSplit";
import SalesProfitTrend from "./SalesProfitTrend";
import TopCustomers from "./TopCustomers";

const Dashboard = () => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/auth/login"} replace={true} />;
	}

	const accessToken = localStorage.getItem("access-token");
	if (accessToken && !checkTokenExp(accessToken)) {
		logout();
		return null;
	}

	return (
		<>
			<div className="dashboard-page">
				<div className="dashboard-page-fixed">
					<Row>
						<Col span={24}>
							<DemoLine />
						</Col>
					</Row>
				</div>
				<div className="dashboard-page-scroll">
					<div className="dashboard-page-content">
						<Row gutter={[12, 12]}>
							<Col xs={24} lg={12}>
								<SalesProfitTrend />
							</Col>
							<Col xs={24} lg={12}>
								<QuickMetrics />
							</Col>
							<Col xs={24} lg={12}>
								<TopCustomers />
							</Col>
							<Col xs={24} lg={12}>
								<SalePurchaseSplit />
							</Col>
						</Row>
					</div>
				</div>
			</div>
		</>
	);
};

export default Dashboard;
